export const $=(s,r=document)=>r.querySelector(s);

export const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

export const uid=()=>Math.random().toString(36).slice(2,9);

export const TODAY=(()=>{const d=new Date();d.setHours(0,0,0,0);return d})();

export const iso=d=>d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');

export const off=n=>{const d=new Date(TODAY);d.setDate(d.getDate()+n);return iso(d)};

export const pd=s=>{const a=s.split('-').map(Number);return new Date(a[0],a[1]-1,a[2])};

export const daysTo=s=>Math.round((pd(s)-TODAY)/864e5);

export const MON=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const fmtD=s=>{if(!s)return'No date';const d=pd(s);return MON[d.getMonth()]+' '+d.getDate()};

export const fmtSize=n=>n>1048576?(n/1048576).toFixed(1)+' MB':Math.max(1,Math.round(n/1024))+' KB';

export const mmss=t=>Math.floor(t/60)+':'+String(Math.floor(t%60)).padStart(2,'0');

export const DAYS=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

export const fmtLong=s=>{if(!s)return '';const d=pd(s);return DAYS[d.getDay()]+' '+d.getDate()+' '+MON[d.getMonth()]};

export const agoT=t=>{const m=Math.max(1,Math.round((Date.now()-t)/60000));return m<60?m+' min ago':m<1440?Math.round(m/60)+' hr ago':Math.round(m/1440)+' days ago'};

export const M=n=>(n<0?'-':'')+'$'+Math.round(Math.abs(n)).toLocaleString('en-AU');

export const Kc=v=>(v<0?'-':'')+'$'+(Math.abs(v)/1000).toFixed(Math.abs(v)>=10000?0:1)+'k';

export const toMin=t=>{const a=String(t||'0:0').split(':').map(Number);return (a[0]||0)*60+(a[1]||0)};

export const addDays=(s0,n)=>{const d=pd(s0);d.setDate(d.getDate()+n);return iso(d)};

export function weekStartIso(offWeeks){const d=new Date(TODAY);d.setDate(d.getDate()-((d.getDay()+6)%7)+7*(offWeeks||0));return iso(d)}

export const val=id=>{const e=document.getElementById(id);return e?e.value.trim():''};

export function readImg(file,cb){
  const fr=new FileReader();fr.onload=()=>{const im=new Image();im.onload=()=>{const k=Math.min(1,900/im.width);const cv=document.createElement('canvas');cv.width=im.width*k;cv.height=im.height*k;cv.getContext('2d').drawImage(im,0,0,cv.width,cv.height);cb(cv.toDataURL('image/jpeg',.82),im.width,im.height)};im.onerror=()=>cb(null);im.src=fr.result};fr.readAsDataURL(file);
}
